import styled from 'styled-components';

import LogoImg from './logo.svg';

export const Wrapper = styled.nav`
  display: flex;
  align-items: center;
  background-color: var(--header-background-primary);
  max-width: 100%;
`;

export const Container = styled.div`
  width: var(--content-width);
  margin: 0 auto;
  height: 80px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SelectorWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

export const Logo = styled.img.attrs({
  src: `${LogoImg}`,
})``;

export const OrganizationLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 41px;
  position: relative;
  max-width: 100%;

  &::before {
    content: ' x ';
    position: absolute;
    color: #fff;
    left: 0;
    padding-left: 16px;
    font-weight: bold;
  }
`;

export const OrganizationLogo = styled.img`
  height: 32px;
`;

export const AvatarImg = styled.img``;
